import { mobileInputName, SHAPARAK_URL } from '../constants';
import { CreateTokenRequest } from '@libs/api-reference';

type OpenApGatewayParamsType = {
  token: string;
  mobile?: string;
  gateway: string;
};

function createDepositRedirectURL(token: string) {
  return `${SHAPARAK_URL}/SendToken?token=${token}`;
}

function openGateway({ token, mobile, gateway }: OpenApGatewayParamsType) {
  const form = document.createElement('form');
  const tokenInput = document.createElement('input');
  const mobileInput = document.createElement('input');

  form.setAttribute('method', 'POST');
  form.setAttribute('action', gateway);
  form.setAttribute('target', '_self');

  tokenInput.setAttribute('name', 'RefId');
  tokenInput.setAttribute('value', token);

  if (mobile) {
    mobileInput.setAttribute('name', mobileInputName[gateway]);
    mobileInput.setAttribute('value', mobile);
  }

  form.appendChild(tokenInput);
  form.appendChild(mobileInput);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

function paymentTokenFactory(form: CreateTokenRequest) {
  return {
    totalAmount: form.totalAmount,
    bankAccountUsageType: 8, // SecuritiesExchange
    deviceType: 3, // Helium
  };
}

export { openGateway, createDepositRedirectURL, paymentTokenFactory };
